// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"98":"cf60d57f","288":"4be3c443","364":"6cc70c95","772":"75254090"}[chunkId] + ".js";
};